module.exports = __webpack_public_path__ + "img/sectionCover1.007b391f.png";